module.exports = __webpack_public_path__ + "img/prijsPro.e92ea296.svg";